import React from "react";
import { FaFacebookF, FaYoutube, FaInstagram, FaLinkedinIn, FaGoogle, FaWhatsapp } from "react-icons/fa";
import { IoMdCall, IoMdMail } from "react-icons/io";
import logo from "../../Asset/SAI STEELS.png";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-[#114497] text-white py-10">
      <div className="max-w-screen-xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8 px-6">
        
        {/* About Section */}
        <div>
          <img src={logo} alt="Sai Steel Logo" className="w-auto h-24 mb-4" />
          <p className="text-sm">
            The Sai Steel was established in 2014 and has carved out a remarkable place amongst customers throughout.
          </p>
          {/* Social Media Icons */}
                  <div className="flex gap-3 mt-3 text-lg">
           <a href="https://www.facebook.com/saisteelsindia/" target="_blank" rel="noopener noreferrer">
             <FaFacebookF className="hover:text-blue-600" />
           </a>
           <a href="https://www.google.com/search?q=Sai+Steels&stick=H4sIAAAAAAAA_-NgU1I1qDBOSkwxtjRISk4yNDRLNra0MqgwN01NMTU1T7MwTTY1Tk1NXsTKFZyYqRBckpqaUwwAl7ksdTYAAAA&hl=en&mat=CZfZv2ZtBM0DElcBmzl_pYWSN8TgeBLoM2GXS3X5F-I2sQG51oHsHNsVBkaOsKZnIUNT1vg9pwXK2jJChQ1VlcXVJ_o2TQDDKj1tb7vr87F-cgCLulIjH47aPkMZgFMCh94&authuser=0" target="_blank" rel="noopener noreferrer">
             <FaGoogle className="hover:text-pink-400" />
           </a>
           <a href="https://wa.me/+919094793999" target="_blank" rel="noopener noreferrer">
             <FaWhatsapp className="hover:text-green-600" />
           </a>
           <a href="https://www.instagram.com/saisteelsvellore/" target="_blank" rel="noopener noreferrer">
             <FaInstagram className="hover:text-pink-600" />
           </a>
         </div>
        </div>

    {/* Quick Links */}
<div>
  <h3 className="text-lg font-semibold text-white mb-3">Quick Links</h3>
  <ul className="space-y-2">
    {["Home", "About us", "Products", "Contact Us"].map((item) => (
      <li key={item}>
        <Link
          to={
            item === "Home"
              ? "/"
              : item === "About us"
              ? "/about"
              : item === "Products"
              ? "/products"
              : item === "Contact Us"
              ? "/contact"
              : "/"
          }
          className="hover:text-white"
        >
          {item}
        </Link>
      </li>
    ))}
  </ul>
</div>


        {/* Address Section */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-3">Address</h3>
          <p className="text-sm">
            No. 1, Thiruvika Nagar, <br />Chennai to Bangalore, <br /> NH Service Road, <br /> Rangapuram, Vellore, <br /> Tamil Nadu - 632009
          </p>
          <div className="mt-4">
            <span className="flex items-center gap-2">
              <IoMdCall size={20} className="hover:text-blue-400 text-white cursor-pointer" />
              +91 90947 93999
            </span>
            <span className="flex items-center gap-2 mt-2">
              <IoMdMail size={20} className="hover:text-blue-400 text-white cursor-pointer" />
              ceo@saisteels.com
            </span>
          </div>
        </div>

        {/* Google Map Section */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-3">Find Us</h3>
          <iframe
            title="Sai Steel Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.5129344055586!2d79.16740577454614!3d12.938995915593317!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bad390bcb116c39%3A0x75ed557f85c53eec!2sSai%20Steels!5e0!3m2!1sen!2sin!4v1743161986603!5m2!1sen!2sin"
            width="100%"
            height="200"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="rounded"
          >
            
          </iframe>
 
        </div>
      </div>

 
      {/* Bottom Section */}
<div className="border-t border-white mt-6 pt-4 px-6">
  <div className="max-w-screen-xl mx-auto flex flex-col md:flex-row justify-between items-center text-sm text-white">
    <div>© {new Date().getFullYear()} Sai Steel. All Rights Reserved.</div>
    <div className="mt-2 md:mt-0">
      Designed & Developed by{" "}
      <a
        href="http://greenemeraldbranding.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:underline text-[#fbb613]"
      >
        Green Emerald Branding Agency
      </a>
    </div>
  </div>
</div>

    </footer>
  );
};

export default Footer;
